import { Injectable } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LocalizedTextIds } from '../../../../../company-finder-common/src';

import { DeploymentContext } from '../deployment-context/deployment-context.js';

@Injectable({ providedIn: 'root' })
export class TitleAndMetadata {

  public constructor(
    private titleService: Title,
    private metaService: Meta,
    private context: DeploymentContext
  ) {}

  /** Sets the various header/meta elements to the specified name,
   *  propagating that up to the hosting page per propagateToParent. */
  public setPageTitle(name: string): void {
    const fullTitle = `${name} - ${this.context.Loc(LocalizedTextIds.PageTitleSuffix)}`;
    
    this.titleService.setTitle(fullTitle);
    this.upsertMetaTag('og:title', fullTitle, 'property');
    this.upsertMetaTag('twitter:title', fullTitle);

    this.context.sendMessageToIframe({ for: 'title', operation: 'change', name: fullTitle });
  }

	public upsertMetaTagDescription(content: string): void {
		this.upsertMetaTag('description', content);
		this.upsertMetaTag('og:description', content, 'property');
		this.upsertMetaTag('twitter:description', content);
	}

  public upsertMetaTag(
    name: string,
    content: string,
    attribute: string = 'name'
  ): void {
    const attrSelector = `${attribute}='${name}'`;
    const tag = {
      content: content,
    };
    tag[attribute] = name;
    if (this.metaService.getTag(attrSelector)) {
      this.metaService.updateTag(tag, attrSelector);
    } else {
      this.metaService.addTag(tag, false);
    }

		this.context.sendMessageToIframe({
			for: 'meta',
			operation: 'change',
			attribute: attribute,
			name: name,
			content: content,
		});
	}
}
